import React, { useEffect, useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../redux/configureStore';
import getDashboard from '../../../../redux/fetchActions/legadoPage/dashboardApp';
import Card from '../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../shared/components/Card/components/CardComponents';
import Wrapper from '../../../../shared/components/Wrapper';
import theme from '../../../../styles/theme';
import checkValue, { convertToPercentage } from '../../../../utils/values';
import Frame from './components/Frame';
import PieChart from './components/PieChart';

function Dashboard() {
  const dispatch = useDispatch();
  const dashboardState = useSelector((reducer: IReducer) => reducer.dashboard);

  const isLoading = useMemo(() => {
    if (dashboardState.isLoading) {
      return (
        <Wrapper.Default margin="25% 0 0 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [dashboardState.isLoading]);

  useEffect(() => {
    if (
      !dashboardState.gotError &&
      !dashboardState.gotSuccess &&
      !dashboardState.isLoading
    )
      dispatch(getDashboard());
  }, [
    dashboardState.gotError,
    dashboardState.isLoading,
    dashboardState.gotSuccess,
  ]);

  return (
    <>
      {isLoading}
      <Frame.Base isActive={dashboardState.gotSuccess}>
        <Card
          isActive
          title="Saldo na Conta Liquidação"
          display="flex"
          gridArea="cl"
          justifyContent="space-around"
          flexDirection="column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Global</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.clTotalValue).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Fidúcia</CardLabel>
            <CardValue color={theme.colors.emphasis}>
              {checkValue(dashboardState.clFiduciaValue).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Parceiros</CardLabel>
            <CardValue color={theme.colors.blue}>
              {checkValue(dashboardState.clThirdPartyValue).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Total de Clientes"
          display="flex"
          gridArea="clients"
          justifyContent="space-around"
          flexDirection="column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Global</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.allClients)}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Fidúcia</CardLabel>
            <CardValue color={theme.colors.emphasis}>
              {checkValue(dashboardState.fiduciaClients)}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Parceiros</CardLabel>
            <CardValue color={theme.colors.blue}>
              {checkValue(
                dashboardState.allClients - dashboardState.fiduciaClients
              )}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Tarifas Acumuladas"
          display="flex"
          gridArea="fares"
          justifyContent="space-around"
          flexDirection="Column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>TEDs</CardLabel>
            <CardValue color={theme.colors.emphasis}>
              {checkValue(dashboardState.tedFaresFiduciaValue).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Manutenção de Contas</CardLabel>
            <CardValue color={theme.colors.emphasis}>
              {checkValue(
                dashboardState.monthlyFaresFiduciaValue
              ).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Boletos</CardLabel>
            <CardValue color={theme.colors.emphasis}>
              {checkValue(
                dashboardState.boletoFaresFiduciaValue
              ).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Parceiros"
          display="flex"
          gridArea="partners"
          justifyContent="space-around"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Total</CardLabel>
            <CardValue color={theme.colors.blue}>
              {checkValue(dashboardState.amountPartners - 1)}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Usuários"
          display="flex"
          gridArea="users"
          justifyContent="space-around"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Total</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.amountUsers)}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Resumo de Boletos"
          display="flex"
          gridArea="boleto"
          justifyContent="space-around"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <Wrapper.Default isActive justifyContent="space-around" heigth="100%">
            <LabelAndValueContainer alignCenter>
              <CardLabel>Qtd. Total</CardLabel>
              <CardValue color={theme.colors.mainColor}>
                {checkValue(dashboardState.totalValueBoletos)}
              </CardValue>
            </LabelAndValueContainer>
            <LabelAndValueContainer alignCenter>
              <CardLabel>Qtd. Liquidados</CardLabel>
              <CardValue color={theme.colors.emphasis}>
                {checkValue(dashboardState.totalValueBoletosPaid)}
              </CardValue>
            </LabelAndValueContainer>
            <LabelAndValueContainer alignCenter>
              <CardLabel>Qtd.Cancelado</CardLabel>
              <CardValue color={theme.colors.red}>
                {checkValue(dashboardState.amountBoletosCanceled)}
              </CardValue>
            </LabelAndValueContainer>
            <LabelAndValueContainer alignCenter>
              <CardLabel>Qtd.Pendentes</CardLabel>
              <CardValue color={theme.colors.lightGray}>
                {checkValue(
                  dashboardState.totalValueBoletos -
                    dashboardState.totalValueBoletosPaid -
                    dashboardState.amountBoletosCanceled
                )}
              </CardValue>
            </LabelAndValueContainer>
          </Wrapper.Default>
          <Wrapper.Default isActive heigth="90%" width="50%">
            <PieChart
              data={[
                convertToPercentage(
                  dashboardState.totalValueBoletos,
                  dashboardState.totalValueBoletosPaid
                ),
                convertToPercentage(
                  dashboardState.totalValueBoletos,
                  dashboardState.amountBoletosCanceled
                ),
                convertToPercentage(
                  dashboardState.totalValueBoletos,
                  dashboardState.totalValueBoletos -
                    dashboardState.totalValueBoletosPaid -
                    dashboardState.amountBoletosCanceled
                ),
              ]}
              backgroundColors={[
                theme.colors.emphasis,
                theme.colors.red,
                theme.colors.gray,
              ]}
              hoverBackgroundColors={[
                theme.colors.accent,
                theme.colors.hoverRed,
                theme.colors.lightGray,
              ]}
              labels={['% Liquidado', '% Cancelado', '% Pendente']}
            />
          </Wrapper.Default>
        </Card>

        <Card
          isActive
          title="Resumo de TEDs"
          display="flex"
          gridArea="ted"
          justifyContent="space-around"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <Wrapper.Default isActive justifyContent="space-around" heigth="100%">
            <LabelAndValueContainer alignCenter>
              <CardLabel>Valor Recebido</CardLabel>
              <CardValue color={theme.colors.emphasis}>
                {checkValue(dashboardState.tedValueReceived).toLocaleString(
                  'pt-br',
                  {
                    style: 'currency',
                    currency: 'BRL',
                  }
                )}
              </CardValue>
              <CardLabel>Qtd. Recebida</CardLabel>
              <CardValue>{dashboardState.amountTedReceived}</CardValue>
            </LabelAndValueContainer>
            <LabelAndValueContainer alignCenter>
              <CardLabel>Valor Enviado</CardLabel>
              <CardValue color={theme.colors.blue}>
                {checkValue(dashboardState.tedValueCarriedOut).toLocaleString(
                  'pt-br',
                  {
                    style: 'currency',
                    currency: 'BRL',
                  }
                )}
              </CardValue>
              <CardLabel>Qtd. Enviada</CardLabel>
              <CardValue>{dashboardState.amountTedCarriedOut}</CardValue>
            </LabelAndValueContainer>
            <LabelAndValueContainer alignCenter>
              <CardLabel>Qtd. Agendada</CardLabel>
              <CardValue color={theme.colors.lightGray}>
                {checkValue(dashboardState.amountScheduledTranfers)}
              </CardValue>
            </LabelAndValueContainer>
          </Wrapper.Default>
          <Wrapper.Default isActive heigth="90%" width="50%">
            <PieChart
              data={[
                convertToPercentage(
                  dashboardState.tedValueReceived +
                    dashboardState.tedValueCarriedOut,
                  dashboardState.tedValueReceived
                ),
                convertToPercentage(
                  dashboardState.tedValueReceived +
                    dashboardState.tedValueCarriedOut,
                  dashboardState.tedValueCarriedOut
                ),
              ]}
              backgroundColors={[theme.colors.emphasis, theme.colors.blue]}
              hoverBackgroundColors={[
                theme.colors.accent,
                theme.colors.hoverBlue,
              ]}
              labels={['% Recebida', '% Enviada']}
            />
          </Wrapper.Default>
        </Card>

        <Card
          isActive
          title="TEV Transacionado"
          display="flex"
          gridArea="tev"
          justifyContent="space-around"
          flexDirection="column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Total</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.tevTransacted.value).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
          <LabelAndValueContainer alignCenter>
            <CardLabel>Quantidade</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.tevTransacted.amount)}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Pagamentos"
          display="flex"
          gridArea="paids"
          justifyContent="space-around"
          flexDirection="column"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Total</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.totalBoletosPaid).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
        </Card>

        <Card
          isActive
          title="Recargas"
          display="flex"
          gridArea="recharge"
          justifyContent="space-around"
          flexDirection="row"
          height="100%"
          width="100%"
          backgroundColor="#FFFFFF">
          <LabelAndValueContainer alignCenter>
            <CardLabel>Total</CardLabel>
            <CardValue color={theme.colors.mainColor}>
              {checkValue(dashboardState.amountCellRecharge).toLocaleString(
                'pt-br',
                {
                  style: 'currency',
                  currency: 'BRL',
                }
              )}
            </CardValue>
          </LabelAndValueContainer>
        </Card>
      </Frame.Base>
    </>
  );
}

export default Dashboard;
